import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { LanguageProvider } from '@contexts/LanguageContext';
import RuntimeConfigProvider from '@contexts/RuntimeConfigContext';
import App from './containers/App';
import store from './store';
import './index.css';
if (typeof window !== 'undefined') {
    window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ = true;
}
Sentry.init({
    dsn: 'https://9a9fed50d3a090cb7d7f76a46b37e6d1@sentry.talview.com/211',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            networkDetailAllowUrls: [
                'https://supergraph.talview.com/v1/graphql',
                'https://top-api.talview.org/v1/graphql',
                'https://api.talview.com/v1/graphql',
            ],
            // Opt out of blanket masking — use data-sentry-mask on PII fields instead
            maskAllText: false,
            blockAllMedia: false,
            mask: ['[data-sentry-mask]'],
            block: ['[data-sentry-block]'],
            // Explicit cap — assessments can be long but Sentry default is already 60 min
            maxReplayDuration: 3_600_000,
        }),
        // Records canvas elements (webcam feed, face-detection overlay, HardwareTest preview)
        Sentry.replayCanvasIntegration(),
    ],
    release: process.env.VERSION || 'dev',
    environment: process.env.APP_ENV || process.env.NODE_ENV || 'internal',
    enabled: process.env.NODE_ENV !== 'development',
    // tracePropagationTargets: [
    //   'https://supergraph.talview.com/v1/graphql',
    //   'https://top-api.talview.org/v1/graphql',
    //   'https://api.talview.com/v1/graphql',
    // ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 10,
});
console.log('App version: ', process.env.VERSION);
const rootElement = document.getElementById('root');
let root;
if (rootElement) {
    root = createRoot(rootElement);
}
const renderApp = () => {
    if (root && root.render) {
        root.render(_jsx(React.StrictMode, { children: _jsx(RuntimeConfigProvider, { children: _jsx(Provider, { store: store, children: _jsx(LanguageProvider, { children: _jsx(App, {}) }) }) }) }));
    }
    else {
        console.error('Root element with id "root" not found in the document.');
    }
};
if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./containers/App', renderApp);
}
renderApp();
